import React from 'react';
import Menu from '../Menu';
import { menuLinks, sections, bestPracticesDefault } from '../constants'
import ils_15 from './../images/assets/ils_15.svg';
import ServiceContent from './ServiceContent';

const title = 'LLM, Agents & Agentic Workflows'
const description = 'Harness the power of Large Language Models through AWS Bedrock and custom fine-tuning to build intelligent agentic systems. We specialize in creating multi-agent workflows that autonomously handle complex business processes, from customer support to document processing. Our expertise spans AWS Bedrock models (Claude, Llama, Mistral), custom Llama fine-tuning, RAG systems, and LangChain-powered agentic frameworks. Build AI systems that don\'t just respond—they think, plan, and execute.'

const useCases = [
	'Multi-agent customer support systems with intelligent routing and escalation',
	'Domain-specific LLM fine-tuning (Llama) for specialized industries',
	'Agentic workflow orchestration using LangChain for complex business processes',
	'RAG-based knowledge management systems with real-time data retrieval',
	'LLM-powered content generation with consistent brand voice and style',
	'Automated document processing, analysis, and intelligent summarization',
	'Sentiment analysis and classification at scale',
	'Conversational AI and intelligent chatbots with context awareness',
	'AWS Bedrock model selection and optimization for specific use cases'
]
const bestPractices = bestPracticesDefault.concat([
	'Leverage AWS Bedrock for managed LLM infrastructure (Claude, Llama, Mistral)',
	'Custom Llama fine-tuning for domain-specific applications',
	'Implement RAG patterns for enhanced accuracy and up-to-date information',
	'Build agentic workflows with LangChain for multi-step reasoning',
	'Optimize prompt engineering strategies for different model families',
	'Deploy scalable inference with GPU acceleration when needed'
])

const faqs = [
	{
		question: "What are agentic AI workflows and how do they differ from traditional LLM applications?",
		answer: "Agentic AI workflows use autonomous AI agents that can think, plan, and execute multi-step tasks independently. Unlike traditional LLM applications that respond to single prompts, agentic workflows orchestrate multiple AI agents using frameworks like LangChain and LangGraph to handle complex business processes such as customer support routing, document processing, and multi-step reasoning tasks."
	},
	{
		question: "What is RAG and why does it matter for enterprise AI?",
		answer: "RAG (Retrieval-Augmented Generation) is a technique that enhances LLM responses by retrieving relevant information from your organization's data before generating answers. This ensures AI responses are grounded in accurate, up-to-date company data rather than relying solely on the model's training data. CaptainMe AI builds RAG systems using vector databases like Pinecone and Weaviate integrated with AWS Bedrock."
	},
	{
		question: "How does custom LLM fine-tuning work with AWS Bedrock?",
		answer: "Custom LLM fine-tuning on AWS Bedrock involves training foundation models like Llama and Mistral on your domain-specific data to improve accuracy for specialized tasks. CaptainMe AI handles the full pipeline: data preparation, model selection, fine-tuning configuration, evaluation, and deployment with auto-scaling inference endpoints."
	}
]

function ServicesNaturalLanguageProcessing() {
	return (
		<React.Fragment>
			< Menu />

			<ServiceContent
				pageTitle='LLM, Agents & Agentic Workflows'
				title={title}
				description={description}
				useCases={useCases}
				bestPractices={bestPractices}
				img={ils_15}
				techDescription=''
				breadCrumpMenu={sections.services.naturalLanguageProcessing.title}
				currentMenuPage={menuLinks.servicesNaturalLanguageProcessing}
				faqs={faqs}
			/>
		</React.Fragment>
	)
}

export default ServicesNaturalLanguageProcessing;
